import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';

import useCustomLayout from 'hooks/useCustomLayout';
import CarouselAutoplay from './CarouselAutoplay';

import { MENU_PLACEMENT, LAYOUT } from 'constants.js';

import Cattle from './Cattle';


const FooterBarCattle= () => {
  const title = 'Welcome to S.M.A.';
  const description = 'Cattle';
  const breadcrumbs = [{ to: '', text: 'Cattle Farming Rehabilitation in the Congo' }];

  

  useCustomLayout({ placement: MENU_PLACEMENT.Horizontal, layout: LAYOUT.Boxed });
return (
    <>

      <Row>
        <Col>
          {/* Carousel Start */}
          <section className="scroll-section" id="carousel">
          <Row xxl="1">
              <Col xs="auto" sm="auto" className="mb-5">
               <CarouselAutoplay />
               </Col>
           </Row>
             </section>
          {/* Carousel End */}

      
          {/* Product Start */}
          <section className="scroll-section" id="Cattle">
          <div className="mb-5">
            <h2 className="cta-2 small-title">Cattle Farming Rehabilitation in the Congo.</h2>
            </div>
            <div className="cta-2 mb-5">
              <Cattle />
            </div>
          </section>
          {/* Product End */}
          
        </Col>
 
      </Row>
    </>
  );

};

export default FooterBarCattle;
